import React, { useState } from 'react';
import { X } from 'lucide-react';
function LegalModal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-49">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-50" />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-51">
        <div className="flex items-center justify-between p-6 border-b border-slate-100" data-id="element-52">
          <h2 className="text-xl font-serif font-bold text-slate-900" data-id="element-53">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 transition-colors text-slate-500" data-id="element-54">
            <X className="w-5 h-5" data-id="element-55" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-sm text-slate-600 leading-relaxed space-y-4" data-id="element-56">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-slate-900 text-slate-400 py-12 px-4 border-t border-slate-800" data-id="element-57">
        <div className="max-w-3xl mx-auto text-center" data-id="element-58">
          <p className="font-serif font-bold text-white text-xl mb-4" data-id="element-59">
            3AM RESET
          </p>
          <p className="text-sm mb-6" data-id="element-60">
            El sistema simple para volver a dormir cuando despiertas entre
            2–4am.
          </p>
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-61">
            <button onClick={() => setOpenModal('privacy')} className="text-sm text-slate-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-62">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-63">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-sm text-slate-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-64">
              Términos y Condiciones
            </button>
          </div>
          <div className="text-xs text-slate-600" data-id="element-65">
            &copy; {new Date().getFullYear()} 3AM RESET. Todos los derechos
            reservados.
          </div>
        </div>
      </footer>

      {openModal === 'privacy' && <LegalModal title="Política de Privacidad" onClose={() => setOpenModal(null)} data-id="element-66">
          <p data-id="element-67">
            <strong data-id="element-68">Última actualización:</strong> Febrero 2026
          </p>
          <p data-id="element-69">
            En 3AM RESET, respetamos tu privacidad y nos comprometemos a
            proteger tu información personal.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-70">
            1. Información que recopilamos
          </h3>
          <p data-id="element-71">
            Recopilamos únicamente la información necesaria para procesar tu
            compra: nombre, correo electrónico y datos de pago. No almacenamos
            datos de tarjetas de crédito directamente; estos son procesados por
            plataformas de pago seguras de terceros.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-72">
            2. Uso de la información
          </h3>
          <p data-id="element-73">
            Tu información se utiliza exclusivamente para: entregar el producto
            digital adquirido, enviarte confirmación de compra y, si lo
            autorizas, enviarte contenido relacionado con bienestar y sueño.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-74">
            3. Compartir información
          </h3>
          <p data-id="element-75">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros, excepto los proveedores de servicios necesarios para
            procesar pagos y entregar el producto.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-76">4. Cookies</h3>
          <p data-id="element-77">
            Este sitio puede utilizar cookies básicas para mejorar tu
            experiencia de navegación. No utilizamos cookies de rastreo
            publicitario.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-78">5. Tus derechos</h3>
          <p data-id="element-79">
            Puedes solicitar acceso, corrección o eliminación de tus datos
            personales en cualquier momento escribiéndonos por correo
            electrónico.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-80">6. Seguridad</h3>
          <p data-id="element-81">
            Implementamos medidas de seguridad razonables para proteger tu
            información. Sin embargo, ningún método de transmisión por Internet
            es 100% seguro.
          </p>
        </LegalModal>}

      {openModal === 'terms' && <LegalModal title="Términos y Condiciones" onClose={() => setOpenModal(null)} data-id="element-82">
          <p data-id="element-83">
            <strong data-id="element-84">Última actualización:</strong> Febrero 2026
          </p>
          <p data-id="element-85">
            Al adquirir 3AM RESET, aceptas los siguientes términos y
            condiciones.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-86">1. Producto digital</h3>
          <p data-id="element-87">
            3AM RESET es un producto digital (PDF) con contenido informativo y
            educativo sobre hábitos de sueño. No constituye asesoría médica,
            diagnóstico ni tratamiento profesional.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-88">2. Uso personal</h3>
          <p data-id="element-89">
            El producto es para uso personal e intransferible. Queda prohibida
            su reproducción, distribución o reventa sin autorización expresa.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-90">3. Resultados</h3>
          <p data-id="element-91">
            Los resultados pueden variar de persona a persona. 3AM RESET ofrece
            herramientas y estrategias basadas en evidencia, pero no garantiza
            resultados específicos. Si tienes condiciones médicas, consulta a un
            profesional de salud.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-92">
            4. Política de reembolso
          </h3>
          <p data-id="element-93">
            Debido a la naturaleza digital del producto, todas las ventas son
            finales. Si tienes algún problema con tu compra, contáctanos y
            haremos lo posible por ayudarte.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-94">
            5. Propiedad intelectual
          </h3>
          <p data-id="element-95">
            Todo el contenido de 3AM RESET, incluyendo textos, diseños y
            materiales, está protegido por derechos de autor.
          </p>
          <h3 className="font-bold text-slate-900 mt-4" data-id="element-96">6. Modificaciones</h3>
          <p data-id="element-97">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios serán efectivos al publicarse en esta página.
          </p>
        </LegalModal>}
    </>;
}